const API_BASE = process.env.REACT_APP_API_URL || '';

export async function getEntitlements(orgId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/entitlements`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch entitlements');
  }
  
  return response.json();
}

export async function getPlans(orgId) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/entitlements/plans`, {
    credentials: 'include',
    headers: {
      'x-org-id': orgId
    }
  });
  
  if (!response.ok) {
    throw new Error('Failed to fetch plans');
  }
  
  const data = await response.json();
  return data.plans;
}

export async function updateEntitlements(orgId, updates) {
  const response = await fetch(`${API_BASE}/orgs/${orgId}/entitlements`, {
    method: 'PATCH',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'x-org-id': orgId
    },
    body: JSON.stringify(updates)
  });
  
  if (!response.ok) {
    const data = await response.json();
    throw new Error(data.error || 'Failed to update entitlements');
  }
  
  const data = await response.json();
  return data.entitlements;
}
